import Vue from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';

dayjs.locale('ja');

// 日付を指定されたフォーマットで返す
function dateString(string, format) {
  if (string) {
    if (format) {
      return dayjs(string).format(format);
    } else {
      return dayjs(string)
        .toISOString()
        .replace(/\.[0-9]+/, '');
    }
  }
  return string;
}

// limitを超えた数値はlimit+の形式で返す
function roundNumberText(number, limit) {
  if (number > limit) {
    return limit + '+';
  }
  return number;
}

Vue.filter('dateString', dateString);
Vue.filter('roundNumberText', roundNumberText);
